/** @jsxImportSource @emotion/react */

import { FormControlLabel } from '@mui/material'
import { Field, useForm, useFormState } from 'react-final-form'
import Checkbox from '@mui/material/Checkbox'
import { useEffect } from 'react'
import { getQuestionTypeConfig } from '../questionTypeConfig'
import * as commonClasses from '../styles'
import * as classes from './styles'

export const MultipleSelectionLabelCheckBox = () => {
  const { values } = useFormState()
  const form = useForm()

  const hasMultipleSelectionLabel = getQuestionTypeConfig(values.type).showMultipleSelectionLabel

  useEffect(() => {
    if (values.id) {
      return
    }

    form.change('showMultipleSelectionLabel', getQuestionTypeConfig(values.type).showMultipleSelectionLabel)
  }, [values.type])

  if (!hasMultipleSelectionLabel) {
    return null
  }

  return (
    <div css={classes.checkboxWrapper}>
      <Field name="showMultipleSelectionLabel" type="checkbox">
        {({ input }) => (
          <FormControlLabel
            label="Show Multiple Selection label (ONE or MORE)"
            control={<Checkbox {...input} />}
            css={commonClasses.checkbox}
          />
        )}
      </Field>
    </div>
  )
}
